"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerFormatters = void 0;
const sg = __importStar(require("@integro/slickg"));
const _ = __importStar(require("lodash"));
const gettext_1 = require("@integro/gettext");
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
function registerFormatters() {
    sg.registerFormatter('dunningLetterBadges', dunningLetterBadges);
    sg.registerFormatter('overdueHighlight', overdueHighlight);
    sg.registerFormatter('routeLink', routeLink);
    sg.registerFormatter('gettext', gettext);
    sg.registerFormatter('user', user);
    sg.registerFormatter('number', number);
    sg.registerFormatter('checkmark', checkmark);
}
exports.registerFormatters = registerFormatters;
function dunningLetterBadges() {
    const romanizeMonths = false;
    const statusToVariant = {
        sent: 'warning',
        delivered: 'success',
        error: 'danger'
    };
    const defaultVariant = 'secondary';
    function $text(data) {
        if (data && data['created_at']) {
            const d = (0, parseISO_1.default)(data['created_at']), monthNum = d.getMonth() + 1, month = romanizeMonths ? (0, gettext_1.romanize)(monthNum) : monthNum;
            return `${month}.${d.getDate()}`;
        }
        return '';
    }
    function $variant(data) {
        let result;
        if (data && data['status']) {
            result = statusToVariant[data['status']];
        }
        return result || defaultVariant;
    }
    const formatter = (row, cell, value, columnDef, dataContext, grid) => {
        if (!value || value.length === 0) {
            return '';
        }
        return _.map(value, (val, i) => {
            const variant = $variant(val), refnum = val.reference_number, id = val.id, text = $text(val);
            return (`<a href="#" title="${refnum}" data-value="${id}"` +
                `class="badge badge-pill badge-${variant}">${text}</a>`);
        }).join(' ');
    };
    const getCellValue = (row, cell, value, columnDef, dataContext, grid) => {
        if (!value || value.length === 0) {
            return '';
        }
        return _.map(value, (val, i) => $text(val)).join(' ');
    };
    const exportDataFormatter = (row, cell, value, columnDef, dataContext) => {
        if (!value || value.length === 0) {
            return '';
        }
        return _.map(value, (val, i) => {
            const refnum = val.reference_number, text = $text(val);
            return `${text} [${refnum}]`;
        }).join(', ');
    };
    _.set(formatter, 'getCellValue', getCellValue);
    _.set(formatter, 'exportDataFormatter', exportDataFormatter);
    return formatter;
}
function overdueHighlight() {
    function getClassName(value) {
        if (_.isNumber(value) && value > 0) {
            const level = value < 35 ? 1 : value < 50 ? 2 : value < 65 ? 3 : 4;
            return `overdue highlight-${level}`;
        }
    }
    const overdueHighlightFormatter = (row, cell, value, columnDef, dataContext) => {
        if (value == null) {
            return '';
        }
        const className = getClassName(value) || '';
        return `<span class="${className}">${value}</span>`;
    };
    _.set(overdueHighlightFormatter, 'exportRawData', true);
    _.set(overdueHighlightFormatter, 'filterRawData', true);
    return overdueHighlightFormatter;
}
function routeLink(opts) {
    const exportInnerHTML = _.isBoolean(opts.exportInnerHTML)
        ? opts.exportInnerHTML
        : false;
    const icon = '<i class="fa fa-external-link ml-1 text-muted" aria-hidden="true"></i>';
    const getParams = (data) => {
        const result = {};
        for (const [k, v] of Object.entries(opts.params)) {
            result[k] = _.get(data, v, null);
            if (result[k] === null) {
                return;
            }
        }
        return result;
    };
    const router = window.$app.router;
    const routeLinkFormatter = (row, cell, value, columnDef, dataContext) => {
        if (value == null) {
            return '';
        }
        let params = getParams(dataContext);
        if (!params && _.isObject(value)) {
            params = getParams(value);
        }
        if (!params) {
            return opts.innerHTML || value;
        }
        const url = router.resolve({ name: `app.${opts.to}`, params }).href;
        let extras = '';
        if (opts.target) {
            extras += ` target="${opts.target}"`;
        }
        let content = opts.innerHTML || value;
        if (opts.navigateOnIconClick) {
            return `<a class="link-dark" href="${url}" ${extras.trim()}> ${content} <a href="${url}" ${extras.trim()}>${icon}</a>`;
        }
        return `<a href="${url}" ${extras.trim()}>${content}</a>`;
    };
    const exportDataFormatter = (row, cell, value, columnDef, dataContext) => {
        if (value == null) {
            return '';
        }
        if (!exportInnerHTML) {
            return value;
        }
        return opts.innerHTML || value;
    };
    _.set(routeLinkFormatter, 'exportDataFormatter', exportDataFormatter);
    return routeLinkFormatter;
}
function gettext(opts) {
    const result = (function gettextFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) {
            return '';
        }
        return window.$translate.translate({ msgid: value, ...opts });
    });
    _.set(result, 'filterFormattedData', true);
    return result;
}
function user() {
    const users = window.$app.users;
    return (function userFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) {
            return '';
        }
        return users.getUserDisplayName(value);
    });
}
function number() {
    const filter = window.$app.i18n.filters.number;
    const numberFormatter = (row, cell, value, columnDef, dataContext) => {
        if (value == null) {
            return '';
        }
        return filter(value);
    };
    _.set(numberFormatter, 'exportRawData', true);
    return numberFormatter;
}
const checkmark_true = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill="currentColor" d="M9.765 3.205a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.075.015L2.22 6.53a.75.75 0 0 1 1.06-1.06l1.705 1.704l3.72-3.939a.75.75 0 0 1 1.06-.03Z"/></svg>';
function checkmark() {
    const checkmarkFormatter = (row, cell, value, columnDef, dataContext) => {
        if (value === true || value === 1) {
            return checkmark_true;
        }
        return '';
    };
    _.set(checkmarkFormatter, 'exportRawData', true);
    return checkmarkFormatter;
}
//# sourceMappingURL=formatters.js.map